import { render } from "./EditorialFlairImage.vue?vue&type=template&id=8a786b52&scoped=true"
import script from "./EditorialFlairImage.vue?vue&type=script&lang=js"
export * from "./EditorialFlairImage.vue?vue&type=script&lang=js"

import "./EditorialFlairImage.vue?vue&type=style&index=0&id=8a786b52&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a786b52"]])

export default __exports__